import { render, staticRenderFns } from "./DoctorSearchPanel.vue?vue&type=template&id=0ade274c&"
import script from "./DoctorSearchPanel.vue?vue&type=script&lang=js&"
export * from "./DoctorSearchPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports